import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cardShip",
  "use": "icon-cardShip-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cardShip\"><path d=\"M942.933333 618.666667l-38.4-38.4 29.866667-29.866667L1024 640l-89.6 89.6-29.866667-29.866667 38.4-38.4h-196.266666v-42.666666h196.266666zM409.6 473.6l123.733333 72.533333 294.4-170.666666-128-72.533334-290.133333 170.666667z m-42.666667-21.333333l294.4-170.666667-128-72.533333-294.4 170.666666 128 72.533334zM213.333333 413.866667v260.266666l298.666667 170.666667v-260.266667l-298.666667-170.666666z m640 0l-298.666666 170.666666v260.266667l217.6-123.733333 38.4 29.866666-277.333334 157.866667L170.666667 699.733333V366.933333l362.666666-209.066666L896 366.933333V554.666667h-42.666667V413.866667z\" p-id=\"1280\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/cardShip.svg
// module id = /OEl
// module chunks = 51